import { BottomArrow } from "@/Icon/BottomArrow";

interface NotifyDropDownProps {
    dropdownOpen?: boolean;
    setDropdownOpen?: React.Dispatch<React.SetStateAction<boolean>>;
    selectedType?: string;
    setSelectedType?: React.Dispatch<React.SetStateAction<string>>;
}

const NotifyDropDown = ({ dropdownOpen, setDropdownOpen, selectedType, setSelectedType }: NotifyDropDownProps) => {
    const filterTypeArr = ["최신순", "오래된 순", "최신 업데이트"];
    return (
            <div
                className="relative flex items-center cursor-pointer select-none w-28"
                onClick={(e) => {
                    e.stopPropagation();
                    setDropdownOpen?.(v => !v);
                }}
            >
                <div className="flex justify-end w-full">
                    <span className="mx-2 text-sm text-right">
                        {selectedType}
                    </span>
                    <div className="flex items-center">
                        <BottomArrow />
                    </div>
                </div>
                {/* 드롭다운 메뉴 */}
                {dropdownOpen && (
                    <div
                        className="absolute z-10 mt-1 bg-white border rounded shadow right-1 w-[100px] top-full"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {filterTypeArr.map((a) => (
                            <div
                                key={a}
                                className={`pr-3 py-2 text-[13px] cursor-pointer text-right hover:bg-orange-50 ${a === selectedType ? "text-orange-500 font-bold" : ""}`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedType?.(a);
                                    setDropdownOpen?.(false);
                                }}
                            >
                                {a}
                            </div>
                        ))}
                    </div>
                )}
            </div>
    )
}

export default NotifyDropDown;